import React from 'react';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { Pause, Play, X, Trash2 } from 'lucide-react';

const statusLabel = {
  queued: 'Na fila',
  uploading: 'Enviando',
  paused: 'Pausado',
  completed: 'Concluído',
  error: 'Erro',
};

const UploadQueue = ({ items, onPause, onResume, onRemove, onCancel }) => {
  if (!items?.length) return null;

  return (
    <div className="space-y-3">
      {items.map((item) => (
        <div
          key={item.id}
          className="rounded-xl border border-white/10 bg-white/5 p-4 space-y-2"
        >
          <div className="flex justify-between gap-2">
            <p className="text-sm font-medium truncate">{item.name}</p>
            <span className="text-xs text-white/50 shrink-0">{statusLabel[item.status] || item.status}</span>
          </div>
          {(item.status === 'uploading' || item.status === 'paused') && (
            <Progress value={item.progress || 0} className="h-2" />
          )}
          {item.error && <p className="text-xs text-red-400">{item.error}</p>}
          <div className="flex flex-wrap gap-2">
            {item.status === 'uploading' && onPause && (
              <Button size="sm" variant="outline" onClick={() => onPause(item.id)}>
                <Pause className="h-3 w-3 mr-1" />
                Pausar
              </Button>
            )}
            {item.status === 'paused' && onResume && (
              <Button size="sm" variant="outline" onClick={() => onResume(item.id)}>
                <Play className="h-3 w-3 mr-1" />
                Retomar
              </Button>
            )}
            {item.status === 'queued' && onRemove && (
              <Button size="sm" variant="ghost" onClick={() => onRemove(item.id)}>
                <Trash2 className="h-3 w-3 mr-1" />
                Remover
              </Button>
            )}
            {(item.status === 'uploading' || item.status === 'paused') && onCancel && (
              <Button size="sm" variant="destructive" onClick={() => onCancel(item.id)}>
                <X className="h-3 w-3 mr-1" />
                Cancelar envio
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UploadQueue;
